module.exports = __webpack_public_path__ + "images/apple-pay.490c51ff50535177f44cb09e8b36cf83.svg";